<script lang="ts">
  import amex from "@images/payment-card-icons/amex.svg"
  import discover from "@images/payment-card-icons/discover.svg"
  import mastercard from "@images/payment-card-icons/mastercard.svg"
  import visa from "@images/payment-card-icons/visa.svg"

  let {
    stripe_payment_method
  }: { stripe_payment_method: StripePaymentMethodType } = $props()
</script>

<div class="flex justify-start items-center">
  {#if !stripe_payment_method}
    <p class="text-sm text-gray-600 italic">No card on file</p>
  {:else}
    <div class="p-2">
      {#if stripe_payment_method.brand === "Visa"}
        <img src={visa} class="w-24 h-24" alt="Visa" />
      {:else if stripe_payment_method.brand === "MasterCard"}
        <img src={mastercard} class="w-24 h-24" alt="MasterCard" />
      {:else if stripe_payment_method.brand === "American Express"}
        <img src={amex} class="w-24 h-24" alt="Amex" />
      {:else if stripe_payment_method.brand === "Discover"}
        <img src={discover} class="w-24 h-24" alt="Discover" />
      {/if}
    </div>
    <div class="p-2">
      <p class="text-base font-bold text-black">
        {stripe_payment_method.brand} ending in {stripe_payment_method.last4}
      </p>
      <p class="text-sm text-gray-600 mt-1">
        Expires {stripe_payment_method.exp_month}/{stripe_payment_method.exp_year}
      </p>
    </div>
  {/if}
</div>
